import { useContext } from 'react';
import { DataTestContext } from './context';
import { useEnrichmentPolicy } from '../../EnrichmentPolicy/useEnrichmentPolicy';
import { isContact } from '../../utils';
export function useDataTest() {
  const machine = useContext(DataTestContext);
  if (!machine) {
    throw new Error('useDataTest must be used within DataTestProvider');
  }
  const {
    state,
    send
  } = machine;
  const {
    context
  } = state;
  const enrichmentPolicy = useEnrichmentPolicy();
  const hasError = state.hasTag('error');
  const isClosing = state.matches('closing');
  const isContactEnrichment = isContact(state.context.enrichmentType);
  const isDone = state.matches('done');
  const isLoading = state.hasTag('loading');
  return {
    enrichmentPolicy,
    errorId: context.errorId,
    hasError,
    isClosing,
    isContactEnrichment,
    isDone,
    isLoading,
    onClose: () => send('CLOSE'),
    onEnrich: () => send('ENRICH'),
    onRetry: () => send('RETRY'),
    properties: context.properties,
    recordsIneligible: context.recordsIneligible,
    recordsEligible: context.recordsEligible,
    recordsSelected: context.recordsSelected,
    recordsEnrichable: context.recordsEnrichable,
    shouldOverwrite: context.shouldOverwrite,
    setShouldOverwrite: shouldOverwrite => send({
      type: 'SET_OVERWRITE',
      data: {
        shouldOverwrite
      }
    })
  };
}